import { createFileRoute } from "@tanstack/react-router";
import { sciHead } from "@/lib/science/sci-route";
import { m } from "@/paraglide/messages";
import { CalculatorPage } from "@/tools/heatmap/pages/CalculatorPage";

export const Route = createFileRoute("/heatmap")({
  ssr: true,
  head: () =>
    sciHead({
      basePath: "/heatmap",
      title: m.heat_meta_title(),
      description: m.heat_meta_description(),
      toolName: m.heat_tool_name(),
      faqs: [
        { q: m.heat_faq_q1(), a: m.heat_faq_a1() },
        { q: m.heat_faq_q2(), a: m.heat_faq_a2() },
        { q: m.heat_faq_q3(), a: m.heat_faq_a3() },
        { q: m.heat_faq_q4(), a: m.heat_faq_a4() },
      ],
    }),
  component: CalculatorPage,
});
